// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"e49a9552","351":"f976cf5c","453":"6fa05133"}[chunkId] + ".chunk.js";
};